import {MentionProvider} from "./plugins/mentionProvider";
import {SlateEditor, MessageComposerProps} from "./SlateEditor";

export const MessageComposer = (props: MessageComposerProps) => {

  return (
    <MentionProvider>
      <SlateEditor {...props} />
    </MentionProvider>
  )
}